import { UIComponentViewImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler, UIComponentState } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ListGroupRowComponentProps, ListGroupRowComponentHandler } from './listgrouprowcomponent';
import * as React from 'react';
import { ListGroupRowCSSStyle } from './listgrouprowcss';
import './groups-row-style.css';

export class ListGroupRowViewImpl extends UIComponentViewImpl<UIDataModel>
{
  


    bindHandlers()
    {
        this.onViewClick = this.onViewClick.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
        this.onDeleteClick = this.onDeleteClick.bind(this);
    }
   constructor(context: BaseContext, handler: UIComponentHandler)
   {
       super(context, handler);

      
   }

    draw(props: ListGroupRowComponentProps, state: UIComponentState, cssStyle: ListGroupRowCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
          <tr id="groups-row-main" style={cssStyle.getWrapperCSSStyle()}>
              <td id="groups-row-group-name-div" style={cssStyle.getGroupNameDivCSSStyle()}>
                  <label id="groups-row-group-name-label" style={cssStyle.getGroupNameLabelCSSStyle()}>
                    {props.groupDto.getGroupName()}
                  </label>
              </td>
              <td id="groups-row-action" onClick={this.onViewClick} style={cssStyle.getActionDivCSSStyle()}>
                    <img style={cssStyle.getViewImgCSSStyle()} width='16px' height='10.6px' src={this.getContext().getResources().getImage("view.svg")}/>
              </td>
              <td id="groups-row-action" onClick={this.onEditClick} style={cssStyle.getActionDivCSSStyle()}>
                     <img style={cssStyle.getEditImgCSSStyle()} width='16px' height='16px' src={this.getContext().getResources().getImage("edit_grey.svg")}/>
              </td>
              <td id="groups-row-action" onClick={this.onDeleteClick} style={cssStyle.getDeleteImgDivCSSStyle()}>
                    <img style={cssStyle.getDeleteImgCSSStyle()} width='16px' height='16px' src={this.getContext().getResources().getImage("delete_trash.svg")}/>
              </td>
              
          </tr>    
         
        );
    }
    
    onViewClick():void
    {
        (this.getUIComponentHandler() as ListGroupRowComponentHandler).onViewClick();
    }

    onEditClick():void
    {
        (this.getUIComponentHandler() as ListGroupRowComponentHandler).onEditClick();
    }

    onDeleteClick():void
    {
        (this.getUIComponentHandler() as ListGroupRowComponentHandler).onDeleteClick();
    }
  
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/listgroup/viewmodel/grouprow/listgrouprowview.tsx